// Name-tag prompt (HER-10, ARCH §28.9, D-TF-137): a one-line text field titled
// "Name this animal" — Enter confirms, Esc cancels, max 24 characters. The sign-editor
// pattern (a small modal, no anvil screen). Client-only (ENG-1).
import { h } from '../h';
import { ENTITY_NAME_MAX } from '../../../sim/engine/saves';
import { NAME_PROMPT_TITLE } from '../../../sim/heredity/name';

/** Open the prompt; `onConfirm` receives the typed text on Enter (an empty confirm is a
 *  cancel). `onClose` runs once however the prompt closes. */
export function openNameTagPrompt(onConfirm: (text: string) => void, onClose: () => void): void {
  const input = h('input', {
    class: 'bb-input', type: 'text', maxLength: ENTITY_NAME_MAX, 'data-testid': 'nametag-input',
  }) as HTMLInputElement;
  input.style.cssText = 'display:block;margin:8px auto 0;padding:4px;width:240px;';
  const panel = h('div', { class: 'bb-nametag', 'data-testid': 'nametag-prompt' },
    h('div', { class: 'bb-nametag-title', 'data-testid': 'nametag-title' }, NAME_PROMPT_TITLE), input);
  panel.style.cssText = 'background:#2b2b2b;color:#fff;padding:16px;border:2px solid #000;text-align:center;';
  const overlay = h('div', { class: 'bb-modal' }, panel);
  overlay.style.cssText = 'position:fixed;inset:0;z-index:1000;display:flex;align-items:center;justify-content:center;background:#0006;';
  document.body.append(overlay);
  let closed = false;
  const close = (): void => {
    if (closed) return;
    closed = true;
    overlay.remove();
    document.removeEventListener('keydown', onKey, true);
    onClose();
  };
  const onKey = (ev: KeyboardEvent): void => {
    if (ev.code === 'Escape') { ev.preventDefault(); ev.stopPropagation(); close(); return; }
    if (ev.code === 'Enter' || ev.code === 'NumpadEnter') {
      ev.preventDefault(); ev.stopPropagation();
      const text = input.value.trim();
      if (text) onConfirm(text);
      close();
    }
  };
  document.addEventListener('keydown', onKey, true);
  input.focus();
}
